import React from 'react';
import { 
  HeroSection, 
  FeaturedShowsCarousel,
  BigPeopleShowsCarousel,
  StatsSection, 
  NewsBentoGrid, 
  AboutTeaser,
  CTASection,
  ClientsSection 
} from '../components/HomeComponents';

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <FeaturedShowsCarousel />
      <BigPeopleShowsCarousel />
      <StatsSection />
      <ClientsSection />
      <AboutTeaser />
      <NewsBentoGrid />
      <CTASection />
    </div>
  );
}
